module.exports = __webpack_public_path__ + "static/media/majorG7.582466e.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorG7.wav
// module id = Y3qO
// module chunks = 0